<template>
  <div
    id="reports"
    class="row"
  >
    <div class="col-12">
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
        @submit.prevent="reset"
        @keydown="form.onKeydown($event)"
      >
        <v-container grid-list-xl>
          <toolbar
            :title="title"
            :loading="form.busy"
            :buttons="buttons"
            @getTransactions="getTransactions"
            @downloadExcel="downloadExcel"
          />
          <v-layout
            id="ref"
            class="wrap justify-space-around form-body"
          >
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-select
                v-model="form.licenceType"
                :items="licenceTypes"
                :rules="[rules.required]"
                label="Tipo de Reporte"
                required
              />
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-menu
                v-model="startMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dateStart"
                    label="Fecha Inicio"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  color="blue darken-1"
                  v-model="form.dateStart"
                  @input="startMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-menu
                v-model="endMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.dateEnd"
                    label="Fecha Fin"
                    readonly
                    v-on="on"
                  />
                </template>
                <v-date-picker
                  color="blue darken-1"
                  v-model="form.dateEnd"
                  @input="endMenu = false"
                />
              </v-menu>
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-select
                v-model="form.estado"
                :items="estados"
                label="Estado"
              />
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-select
                v-model="form.service_id"
                :items="licenciasAll"
                item-value="id"
                item-text="name"
                label="Paquetes"
                placeholder="Todas"
              />
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
            >
              <v-text-field
                v-model="form.rucCompany"
                :rules="[rules.rucLength, rules.rucFormat]"
                label="RIF Empresa"
                maxlength="11"
              />
            </v-col>
            <v-col
              lg="4" md="6" sm="6" cols="12"
               v-if="form.licenceType === '2'"
            >
              <v-text-field
                v-model="form.ruc_distribuidor"
                :rules="[rules.rucLength, rules.rucFormat]"
                label="RIF Distribuidor"
                maxlength="11"
              />
            </v-col>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <v-col
      v-if="show"
      class="subtitle-1 text-center"
      cols="12"
    >
      Cargando por favor espere...
    </v-col>
    <v-progress-linear
      indeterminate
      background-color="success"
      color="yellow darken-2"
      height="10"
      v-if="show"
    ></v-progress-linear>

    <div class="col-12">
      <v-data-table
        v-if="licencias != 0"
        :headers="headers"
        :items="licencias"
        class="elevation-1"
        calculate-widths
      >
      <template v-slot:item.folios="{ item }">
        <span v-if="item.folios == null">0</span>
        <span v-else>{{item.folios}}</span>
      </template>
      <template v-slot:item.fecha_inicio="{ item }">
        <span v-if="!item.fecha_inicio">Ninguna</span>
        <span v-else>{{item.fecha_inicio}}</span>
      </template>
      <template v-slot:item.fecha_fin="{ item }">
        <span v-if="!item.fecha_fin">Ninguna</span>
        <span v-else>{{item.fecha_fin}}</span>
      </template>
      <template v-slot:item.active="{ item }">
        <span v-if="item.active === 1">Activo</span>
        <span v-else>Inactivo</span>
      </template>
      </v-data-table>

    </div>
  </div>
</template>

<script>
import Form from 'vform';
import Toolbar from '~/components/Toolbar';

Form.axios = window.axios;
export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('reportTransaction') };
  },
  components: {
    Toolbar,
  },
  data: () => ({
    title: 'Reporte de Transacciones',
    form: new Form({
      rucCompany: '',
      ruc_distribuidor: '',
      estado: '2',
      dateStart: '',
      dateEnd: '',
      service_id: '0',
      device: '',
      busy: false,
      licenceType: '1',
      typePortal: 'A',
    }),
    apiURL: '/api/catalogs/getAllServices',
    licenceTypes: [
    { value: '1', text: 'Licencias a Empresas' },
    { value: '2', text: 'Licencias a Distribuidores' },
    ],
    estados: [
      { value: '2', text: 'Todos' },
      { value: '1', text: 'Activo' },
      { value: '0', text: 'Inactivo' },
    ],
    valid: false,
    rules: {
      required: (v) => !!v || 'El campo es requerido.',
      numeric: (v) => /^([0-9])*$/.test(v) || 'El campo solo permite caracteres numericos.',
      format: (v) => /^(?=.*[0-9])/.test(v) || 'El campo solo permite caracteres numericos.',
      rucLength: (v) => (!v || v.length === 11) || 'El campo debe tener de 11 caracteres.',
      rucFormat: (v) => !v || /^[V,J,E,P,G]{1}[-][0-9]{9}$/.test(v) || 'El formato no corresponde.',

    },
    startMenu: false,
    endMenu: false,
    allHeaders: [
    {
      text: 'Licencia',
      value: 'name',
      align: 'left',
      sortable: true,
      width: 100,
    },
    {
      text: 'Fecha de Asignación',
      value: 'fecha',
      align: 'left',
      sortable: true,
      width: 200,
    },
    {
      text: 'RIF Empresa',
      value: 'rif',
      align: 'left',
      sortable: true,
      width: 150,
    },
    {
      text: 'Razón Social Empresa',
      value: 'nombre_empresa',
      align: 'left',
      sortable: true,
      width: 200,
    },
    {
      text: 'RIF Distribuidor',
      value: 'identificacion',
      align: 'left',
      sortable: true,
      width: 200,
    },
    {
      text: 'Razón Social Distribuidor',
      value: 'razonSocial',
      align: 'left',
      sortable: true,
      width: 200,
    },
       {
      text: 'Tipo licencia',
      value: 'tipo',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Código',
      value: 'code',
      align: 'left',
      sortable: true,
      width: 150,
    },
    {
      text: 'Total',
      value: 'total',
      align: 'left',
      sortable: true,
    },
    {
      text: 'Fecha Inicio',
      value: 'fecha_inicio',
      align: 'left',
      sortable: true,
      width: 150,
    },
    {
      text: 'Fecha Fin',
      value: 'fecha_fin',
      align: 'left',
      sortable: true,
      width: 150,
    },
    {
      text: 'Estado',
      value: 'active',
      align: 'left',
      sortable: true,
    }],
    licencias: 0,
    show: false,
    value: 0,
    licenciasAll: [],
    titulo: '',
    headers: [],
    buttons: [
      {
        id: 'save',
        icon: 'mdi-file-find',
        name: 'Generar Vista Previa',
        event: 'getTransactions',
        color: 'blue darken-1',
      },
      {
        id: 'cancel',
        icon: 'mdi-download',
        name: 'Descargar Excel',
        event: 'downloadExcel',
        color: 'green',
      },
    ],
  }),
  computed: {
    ref() {
      return this.form.id;
    },
  },

  mounted() {
    this.selectLicencias();
    this.form.dateStart = this.getDate();
    this.form.dateEnd = this.getDate();
  },

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        this.snackbar = true;
        this.form.busy = true;
        this.valid = true;
      }
    },

    getTransactions() {
      this.validate();
      if (this.$refs.form.validate()) {
        this.show = true;
        let filteredFields = [];
        const url = '/api/reportLicences';
        this.form.post(url).then((response) => {
          this.licencias = response.data.items;
          this.headers = this.allHeaders;
          if (this.form.licenceType === '2') {
              filteredFields = ['RIF Empresa', 'Razón Social Empresa'];
          }
          this.headers = this.headers.filter((header) => filteredFields.indexOf(header.text) === -1);
          this.show = false;
        })
        .catch(() => {
        });
      }
    },

    downloadExcel() {
      this.form.busy = true;
      this.show = true;
      if (!this.licencias) {
        this.$store.dispatch('notifications/show', {
          message: 'El archivo Excel NO contiene registros que coincidan con los criterios de búsqueda.',
          type: 'error',
        });
      } else {
        this.show = true;
        this.form.busy = true;
        if (this.form.licenceType === '1') { this.titulo = 'Reporte de Licencias a Empresas'; }
        if (this.form.licenceType === '2') { this.titulo = 'Reporte de Licencias a Distribuidores'; }

        const url = '/api/download_excel_licences/export';
        window.axios({
          method: 'post',
          url,
          responseType: 'arraybuffer',
          data: this.form,
        }).then((response) => {
            this.downloadFile(response, this.titulo);
            this.show = false;
            this.form.busy = false;
        })
        .catch(() => {
          this.show = false;
          this.form.busy = false;
        });
      }
    },

    downloadFile(response, filename) {
      const newBlob = new Blob([response.data], { type: 'application/vnd.ms-excel' });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }
      const data = window.URL.createObjectURL(newBlob);
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename }.xlsx`;
      link.click();
      setTimeout(() => {
        window.URL.revokeObjectURL(data);
      }, 100);
    },

    selectLicencias() {
      window.axios.get(this.apiURL).then((response) => {
        this.licenciasAll.push({
          id: '0',
          name: 'Todos',
          time: '0',
          quantity: '0',
          description: '0',
          comments: '0',
          active: '0',
          service: '0',
          created_at: '0',
          updated_at: '0',
        });
        this.licenciasAll.push(...response.data.items);
      });
    },
    getDate() {
        const date = new Date();
        const y = date.getFullYear();
        const m = (date.getMonth() + 1 < 10) ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
        const d = (date.getDate() < 10) ? `0${date.getDate()}` : date.getDate();
        const fecha = `${y}-${m}-${d}`;
      //  console.log(fecha);
        return fecha;
    },
  },
};
</script>
